import Header from "../../Containers/Header/Header";
import Cover from '../../Containers/Cover/Cover';
import Footer from '../../Containers/Footer/Footer';
import image1 from '../../Images/ProgramsCrop/1.png';
import image2 from '../../Images/ProgramsCrop/2.png';
import image3 from '../../Images/ProgramsCrop/3.png';
import sliderPicture from '../../Images/Slides/1.jpg';
import AboutSections from '../../Containers/AboutSections/AboutSections';
import AboutPrograms from "../../Containers/AboutPrograms/AboutPrograms";
import {useEffect, useState} from 'react';
import classesCss from './About.module.css'
import SuperExpressive from 'super-expressive';


const About = ({URLS}) => {
    const sections = [
        {
            text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ea id magnam praesentium quam. Aliquid beatae corporis dolore enim et fugit labore magni maiores, minima, modi nam repellat sint unde voluptate. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda blanditiis cumque delectus dolorum, ducimus ea earum impedit inventore ipsam molestiae necessitatibus odit quam quibusdam, quisquam recusandae, repellendus sequi? Corporis, tenetur!',
            image: {
                src: sliderPicture,
                height: '300px',
                width: '500px',
            },
            header: 'Who We Are',
            link: {
                href: URLS['Foundation'],
                text: 'Learn More About Foundation',
            }
        },
        {
            text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ea id magnam praesentium quam. Aliquid beatae corporis dolore enim et fugit labore magni maiores, minima, modi nam repellat sint unde voluptate. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda blanditiis cumque delectus dolorum, ducimus ea earum impedit inventore ipsam molestiae necessitatibus odit quam quibusdam, quisquam recusandae, repellendus sequi? Corporis, tenetur!',
            image: {
                src: sliderPicture,
                height: '300px',
                width: '500px',
            },
            header: 'Our Mission',
            link: {
                href: URLS['Mission'],
                text: 'Help Us Help Them',
            }
        },
        {
            text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ea id magnam praesentium quam. Aliquid beatae corporis dolore enim et fugit labore magni maiores, minima, modi nam repellat sint unde voluptate. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda blanditiis cumque delectus dolorum, ducimus ea earum impedit inventore ipsam molestiae necessitatibus odit quam quibusdam, quisquam recusandae, repellendus sequi? Corporis, tenetur!',
            image: {
                src: sliderPicture,
                height: '300px',
                width: '500px',
            },
            header: 'Our Founder',
            link: {
                href: URLS['Moral Leadership'],
                text: 'Meet Manuel',
            }
        },
        {
            text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ea id magnam praesentium quam. Aliquid beatae corporis dolore enim et fugit labore magni maiores, minima, modi nam repellat sint unde voluptate. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda blanditiis cumque delectus dolorum, ducimus ea earum impedit inventore ipsam molestiae necessitatibus odit quam quibusdam, quisquam recusandae, repellendus sequi? Corporis, tenetur!',
            image: {
                src: sliderPicture,
                height: '300px',
                width: '500px',
            },
            header: 'Our Partners',
            link: {
                href: URLS['Join'],
                text: 'Join Us',
            }
        }
    ];

    const [programs, setPrograms] = useState([]);


    useEffect(() => {
        const getPrograms = async () => {
            const resp = await fetch('https://api-tedoi.herokuapp.com/programs').then(response => response.json());
            setPrograms(resp.map(({text, linktext, url, description}) => {
                return {
                    description,
                    title: text,
                    link: {
                        text: linktext,
                        href: url
                    },
                    image: image1,
                }
            }));
        }
        getPrograms();
    }, [])


    const headerStyles = {
        gridColumn: '1/-1',
    }

    const length = Object.values(URLS).filter(value => {
                const regex = SuperExpressive()
                              .startOfInput
                              .string('/programs')
                              .zeroOrMore
                              .anyChar
                              .toRegex();
                return value.search(regex) === 0 && value !== '/programs'
            }).length-1

    return (
        <div className={"grid grid-rows-1 overflow-x-hidden"}>
            <Header URLS={URLS}/>
            <Cover/>
            <AboutSections sections={sections}/>
            <AboutPrograms programs={programs} length={length}/>
            <Footer URLS={URLS}/>
        </div>
    );
};

export default About;
